import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'

import UserCard from '~/components/UserCard'
import { useUserDetailsQuery } from '~/queries/users'
import { capitalize } from '~/utils/string'

const ReviewedByCellRenderer = ({ data }: ICellRendererParams): ReactElement => {
  const { reviewed_by } = data as {
    reviewed_by: string
  }

  const { data: user } = useUserDetailsQuery(reviewed_by)

  if (!reviewed_by) return <div />

  const picture = user?.picture

  const name = user?.name

  return (
    <div className="reviewed-by-cell">
      <UserCard name={capitalize(name)} picture={picture} size="small" />
    </div>
  )
}

export default ReviewedByCellRenderer
